import * as React from 'react'
import * as _ from 'lodash'
import { Button, Form } from 'react-bootstrap'
import moment from 'moment'
import { css } from 'glamor'
import TimePicker from 'rc-time-picker'

import InputDatePicker from '../../../../components/InputDatePicker'
import 'rc-time-picker/assets/index.css';
import { formatDate, parseFloatTotal } from '../../../../utils/utilsT';
import { currentUserIsClient, currentUserIsManager, currentUserIsWorker, getCurrentUserId } from '../../../../utils/currentUser';

import FormPaymentJob from '../../../../components/FormPaymentJob/FormPaymentJob';
import { FormChangingMoveDate } from './FormChangingMoveDate';
import { OptionsActivityType } from '../OptionsFieldsJob';
import { ActivityT, JobT } from '../../../../types/Job';
import { JobMode, workerHasPermission } from '../Job';
import { copyObject } from '../../../../utils';



const format12Hours = 'h:mm A';

const now = moment().hour(0).minute(0);

const styles = {
    inputTimePicker: css({
        border: "none !important",
        borderBottom: "1px solid #ccc !important",
        padding: ".3rem 0.55rem 0 !important",
        height: "2.1rem !important",
        fontSize: "1rem !important",
        ':disabled': {
            color: "#666 !important",
            backgroundColor: '#eeee !important',
        },
    }),
    popupClassName: css({
        ' input': {
            border: "none !important",
            borderBottom: "1px solid #ccc !important",
            padding: ".3rem 0.55rem 0 !important",
            height: "2.1rem !important",
            fontSize: "1rem !important",
        },

    }),

}
interface ActivityProps {
    jobMode: JobMode
    activity: ActivityT
    index: number
    indexLocation: number
    removeActivity(index: number): void
    updateActivity(activityIndex: number, activity: ActivityT): void
    disabled: boolean
    job: JobT
}

const Activity: React.FunctionComponent<ActivityProps> = (props): JSX.Element => {
    const [isReady, setIsReady] = React.useState(false);
    const [originActivity, setOriginActivity] = React.useState(null);
    const [dirtyActivity, setDirtyActivity] = React.useState<ActivityT | null>(null);
    const isManager = currentUserIsManager()
    const isClient = currentUserIsClient()
    const isWorker = currentUserIsWorker()
    const currentUserId = getCurrentUserId()

    const editable = isManager
        || (isClient && (props.job.jobStatus == "inquiring" || (props.job.jobStatus == "scheduled" && props.indexLocation == 0)))
        || (isWorker && workerHasPermission('sales', props.job, currentUserId))

    // deleteable
    const canDeleteActivity = isManager
        || (isClient && (props.job.jobStatus == "inquiring"))
        || (isWorker && workerHasPermission('sales', props.job, currentUserId))


    const hiddenDateForClient = isClient && props.job.jobStatus == "scheduled" && props.indexLocation > 0
    // const editableDateForClient = isClient && (job.jobStatus == "inquiring" || (job.jobStatus == "scheduled" && indexLocation == 0))
    // const [showFormPayment, setShowFormPayment] = React.useState(false);
    const [enabledChangeMoveDate, setEnabledChangeMoveDate] = React.useState(false);


    const [error, setError] = React.useState({
        show: false,
        msg: ''
    })


    React.useEffect(() => {
        setIsReady(true)

    }, []);


    React.useEffect(() => {
        if (isReady && !originActivity) {
            setOriginActivity(props.activity)
        }
    }, [props.activity]);



    const updateActivity = (activityIndex: number, activity: ActivityT): void => {
        if (!originActivity) {
            setOriginActivity(props.activity)
        }
        // if (index == 0 && activityIndex == 0) propagateDate(activity.activityDate)
        props.updateActivity(activityIndex, activity)
    }



    /**
     *
     * @param key
     * @param value
     */
    const onChangeValue = (key: string, value: any): void => {
        let activityClone = copyObject(props.activity)
        activityClone[key] = value
        props.updateActivity(props.index, activityClone)
    }


    const resetErrorMessage = () => {
        setError({
            show: false,
            msg: '',
        })
    }

    return (
        <>
            {/* Job and date start time will be used for scheduled start and date time;
                Activities date and time will be used to add data to actual start and end time and services rendered */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 30px' }}>
                <div>
                    <Form.Label>Activity {props.index + 1}</Form.Label>
                    <Form.Control
                        disabled={!editable}
                        as='select'
                        className='input-material'
                        value={`${props.activity.activityType ? props.activity.activityType : ""}`}
                        onChange={(event: any) => { updateActivity(props.index, { ...props.activity, activityType: event.target.value }) }}>
                        <option></option>
                        {Object.keys(OptionsActivityType).map((key, index) => {
                            return (
                                <option value={key} key={index}>{OptionsActivityType[key]}</option>
                            )
                        })}
                    </Form.Control>
                    {/*props.activity.activityType == '' && (props.activity.startTime != '' || props.activity.startTime != '' || props.activity.endTime != '') && <Form.Text className="text-danger">You must select an activity type.</Form.Text>*/}
                </div>
                {!hiddenDateForClient && <div>
                    <Form.Label>Date</Form.Label>
                    <InputDatePicker
                        disabled={!editable}
                        id={`activity-date-${props.index}`}
                        className="input-material"
                        style={{ width: '100%' }}
                        selectedDate={`${props.activity.activityDate ? props.activity.activityDate : ""}`}
                        onChangeDate={(val) => {
                            console.log("activityDate", val)
                            updateActivity(props.index, { ...props.activity, activityDate: `${val}` })

                        }}
                        onChange={(val) => {

                        }}
                        dateFormat="MM/dd/yyyy"
                        placeholder=""
                    />

                </div>}

                {!hiddenDateForClient && <div className="">
                    <Form.Group className="d-flex flex-column">
                        <Form.Label>Start Time</Form.Label>
                        <TimePicker
                            minuteStep={15}
                            showSecond={false}
                            disabled={!editable}
                            // style={{ width: "100%" }}
                            // defaultValue={now}
                            value={props.activity.startTime ? moment(props.activity.startTime) : null}
                            inputClassName={`input-material ${styles.inputTimePicker}`}
                            popupClassName={` ${styles.popupClassName}`}
                            onChange={(value) => {
                              console.log("Start Time->value",value)
                                if (value == null) {
                                    updateActivity(props.index, { ...props.activity, startTime: null })
                                } else {

                                    updateActivity(props.index, { ...props.activity, startTime: value.toDate().toString() })
                                }
                            }}
                            format={format12Hours}
                            use12Hours
                            inputReadOnly
                        />
                        {/*((props.activity.startTime == '' && props.activity.endTime != '')
                            || ((props.activity.startTime != '' && props.activity.endTime != '') && new Date(props.activity.startTime) == new Date(props.activity.endTime))
                        || (props.activity.startTime != '' && (new Date(props.activity.endTime) < new Date(props.activity.startTime)))) && <Form.Text className="text-danger">You must The start time be before the end time.</Form.Text>*/}
                    </Form.Group>

                </div>}
                {!hiddenDateForClient && <div>
                    <Form.Group className="d-flex flex-column">


                        <Form.Label>End Time</Form.Label>
                        <TimePicker
                            showSecond={false}
                            disabled={!editable}
                            // style={{ width: "100%" }}
                            // defaultValue={now}
                            value={props.activity.endTime ? moment(props.activity.endTime) : null}
                            inputClassName={`input-material ${styles.inputTimePicker}`}
                            popupClassName={` ${styles.popupClassName}`}
                            onChange={(value) => {
                                if (value == null) {
                                    updateActivity(props.index, { ...props.activity, endTime: null })

                                } else {
                                    updateActivity(props.index, { ...props.activity, endTime: value.toDate().toString() })
                                }

                            }}
                            format={format12Hours}
                            use12Hours
                            inputReadOnly
                        />
                        {/*((props.activity.startTime != '' && props.activity.endTime == '')) && <Form.Text className="text-danger">You must input the end time.</Form.Text>*/}
                    </Form.Group>
                </div>}


                {canDeleteActivity && <span
                    onClick={() => { props.removeActivity(props.index) }}
                    style={{ verticalAlign: 'middle', cursor: 'pointer' }}>x</span>}
            </div>
            {(isClient
                && props.indexLocation == 0
                && props.index == 0
                && props.job.jobStatus == "scheduled"
                && (originActivity && !_.isEqual(props.activity, originActivity))) &&
                <div>

                    <FormChangingMoveDate
                        job={props.job}
                        date={props.activity.activityDate}
                        startTime={props.activity.startTime}
                        endTime={props.activity.endTime}
                        show={() => {
                            setEnabledChangeMoveDate(true)
                        }}
                        hide={() => {
                            setEnabledChangeMoveDate(false)
                        }}
                        onCompleteProcessing={() => {
                            setOriginActivity(null)
                            setEnabledChangeMoveDate(false)
                        }}
                    />

                </div>}
        </>
    )
}

export default Activity
